import { render, staticRenderFns } from "./Parser.vue?vue&type=template&id=7511507b&scoped=true"
import script from "./Parser.vue?vue&type=script&lang=js"
export * from "./Parser.vue?vue&type=script&lang=js"
import style0 from "./Parser.vue?vue&type=style&index=0&id=7511507b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511507b",
  null
  
)

export default component.exports